/**
 * Pulls the Widen asset id out of a Widen media URL, e.g.
 * `…widen.net/content/<assetId>/jpeg/…` or `…widen.net/view/video/<assetId>/…`.
 * The id is the `asset_id` GA4 expects on `pdp_content_click` events
 * (aligned with the marketing-library asset ids). Returns `undefined` for
 * non-Widen or malformed URLs so callers can omit the field.
 */
export function extractWidenAssetId(url: string): string | undefined {
	try {
		const u = new URL(url);
		if (!u.hostname.endsWith("widen.net")) return undefined;
		const match = u.pathname.match(
			/^\/(?:content|view\/video)\/([^/]+)(?:\/|$)/
		);
		return match?.[1];
	} catch {
		return undefined;
	}
}
